import { APP_VERSION } from "#app/lib/app-version";

const COOLDOWN_MS = 30_000;
const LAST_ATTEMPTED_KEY = "version-check-last-attempted";

let lastCheckAt = 0;

export async function checkForUpdate(): Promise<void> {
  const now = Date.now();
  if (now - lastCheckAt < COOLDOWN_MS) return;
  lastCheckAt = now;

  try {
    const res = await fetch("/version", { cache: "no-store" });
    if (!res.ok) return;

    const data = await res.json();
    const remote: string | undefined = data?.version;
    if (!remote || remote === APP_VERSION) return;

    try {
      if (sessionStorage.getItem(LAST_ATTEMPTED_KEY) === remote) {
        console.info(`[version-check] already tried to update to ${remote}, skipping`);
        return;
      }
    } catch {}

    console.info(`[version-check] current=${APP_VERSION} remote=${remote} — reloading`);
    try { sessionStorage.setItem(LAST_ATTEMPTED_KEY, remote); } catch {}
    window.location.reload();
  } catch {
    // Network error — do nothing
  }
}
